import api from "./api";
import { CurrencyType } from "../components/References/Curency/currencyType";
export type DeleteCurrencyDto = {
  id: number | string;
};

/*Search & filter */
export const getCurrencyApi = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/currencies?limit=${body.limit}&q=${body.q.toString()}`;

  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }

  return await api.get(url);
};

/*currency select */

export const getCurrencyDropdown = async () => {
  return await api.get("/currencies/dropdown");
};

export const getCurrencyMainDropdown = async (isMain: boolean) => {
  let url = `/currencies/dropdown?isMain=${isMain}`;
  return await api.get(url);
};

export const getCurrency = async () => {
  return await api.get("/currencies");
};

/*currency delete */

export const deleteCurrency = async (dto: DeleteCurrencyDto) => {
  return await api.delete(`/currencies/${dto.id}`);
};

/*currency by id */

export const getCurrencyById = async (currencyId: string | undefined) => {
  if (currencyId) return await api.get(`/currencies/${currencyId}`);
};

/*currency create */

export const createCurrency = async (currencyDetails: CurrencyType) => {
  return await api.post("/currencies", currencyDetails);
};

/*currency edit */

export const editCurrency = async (currencyId: any, body: CurrencyType) => {
  return await api.put(`/currencies/${currencyId}`, body);
};

/*currency rates */

export const getCurrencyRates = async (currencyId: number) => {
  if (currencyId) return await api.get(`/currencies/${currencyId}/rates`);
};
